/**
 * Hidden SEO Content Component
 * Provides semantic HTML content with keywords for search engines
 * Uses screen-reader-only styling so it's invisible to users but indexed by Google
 */
const SEOContent = () => {
  return (
    <div className="sr-only" aria-hidden="false">
      <h1>Royal Middle East International LLC - ROY.INOX - Commercial Kitchen Equipment UAE</h1>
      <h2>Leading F&B Kitchen Equipment Manufacturer in Dubai, Abu Dhabi & UAE Since 1997</h2>
      
      <section>
        <h3>Commercial Kitchen Equipment Services in UAE</h3>
        <p>
          Royal Middle East International LLC (ROY.INOX) is the leading commercial kitchen equipment 
          manufacturer, supplier and installation specialist in the United Arab Emirates. Established 
          in 1997, we have delivered premium F&B kitchen solutions to hotels, restaurants, cafes, 
          culinary schools, cinemas, food trucks, and hospitality venues across Dubai, Abu Dhabi, 
          Sharjah, Ajman, Ras Al Khaimah, Fujairah, and Umm Al Quwain.
        </p>
      </section>

      <section>
        <h3>Our Kitchen Equipment Product Range</h3>
        <ul>
          <li>Commercial Kitchen Equipment Dubai</li>
          <li>Restaurant Kitchen Equipment UAE</li>
          <li>Hotel Kitchen Equipment Abu Dhabi</li>
          <li>Stainless Steel Fabrication Dubai</li>
          <li>Custom Commercial Kitchen Design UAE</li>
          <li>Walk-in Cold Rooms and Freezers Dubai</li>
          <li>Commercial Refrigeration Systems UAE</li>
          <li>Pizza Ovens - Wood Fired, Gas & Electric</li>
          <li>Wine Chillers and Wine Cellars Dubai</li>
          <li>Bar Counters and Serving Stations</li>
          <li>BBQ Grills and Charcoal Grills Commercial</li>
          <li>Refrigerated Display Cases UAE</li>
          <li>Cheese Rooms and Aging Facilities</li>
          <li>Fish Tank Displays for Restaurants</li>
          <li>Food Trucks Manufacturing and Installation</li>
          <li>Culinary School Equipment Setup</li>
          <li>Concession Counters for Cinemas</li>
          <li>Front of House (FOH) Equipment</li>
          <li>Back of House (BOH) Equipment</li>
          <li>Ceiling Mounted Display Shelving</li>
          <li>Circular Bar Counters</li>
          <li>Annual Maintenance Contracts (AMC)</li>
          <li>Commercial Kitchen Repair and Service</li>
          <li>OEM Kitchen Parts Supply UAE</li>
          <li>Emergency Kitchen Equipment Repairs</li>
          <li>Preventive Maintenance Services</li>
          <li>Commercial Ovens and Combi Ovens</li>
          <li>Ice Machines and Ice Storage</li>
          <li>Glass Washers and Dish Washers Commercial</li>
          <li>Food Preparation Machines</li>
          <li>Ice Cream and Gelato Machines</li>
          <li>Coffee Machines - Franke, La Cimbali, WMF, Nuova Simonelli</li>
          <li>Induction Cooking Units</li>
          <li>Exhaust Hoods and Ventilation</li>
          <li>Slicers, Blenders, Mixers</li>
          <li>Vacuum Packing Machines</li>
          <li>Hot Water Dispensers and Water Filters</li>
          <li>Water Softeners for Commercial Kitchens</li>
        </ul>
      </section>

      <section>
        <h3>Areas We Serve in UAE</h3>
        <p>
          Dubai, Abu Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain, 
          Dubai Marina, JBR, Downtown Dubai, Business Bay, DIFC, Palm Jumeirah, 
          Jumeirah, Deira, Bur Dubai, Al Barsha, Dubai Investment Park, Jebel Ali, 
          Yas Island, Saadiyat Island, Corniche Abu Dhabi, Al Ain
        </p>
      </section>

      <section>
        <h3>Our Prestigious Clients and Projects</h3>
        <p>
          We have delivered custom kitchen equipment for world-renowned establishments including 
          Nobu Atlantis The Palm, Frantzén Atlantis The Palm, Bread Street Kitchen Gordon Ramsay, 
          Epicure Culinary School, Les Roches Culinary School Abu Dhabi, RÜYA Turkish Restaurant, 
          Zuma Dubai, Le Meridien Dubai, Cinepolis Cinema, IFZA, and many more premium hotels, 
          restaurants, and hospitality venues across the UAE.
        </p>
      </section>

      <section>
        <h3>Trusted Equipment Brand Partners</h3>
        <p>
          We are authorized dealers and installers for over 90 world-class brands including 
          Rational, Electrolux, Hobart, Miele, Winterhalter, MKN, Charvet, Molteni, Ambach, 
          Angelo Po, Falcon, Fujimak, Henny Penny, Frymaster, Pitco, Alto-Shaam, Cambro, 
          Hatco, Hoshizaki, Scotsman, Follett, Carpigiani, Vitamix, KitchenAid, Robot Coupe, 
          Bosch, Siemens, Rubbermaid, Everpure, Marco, Zip, and many more premium manufacturers.
        </p>
      </section>

      <section>
        <h3>Certifications and Quality Standards</h3>
        <p>
          ROY.INOX is proudly certified with ISO 9001:2015 (Quality Management), 
          ISO 14001:2015 (Environmental Management), and ISO 45001:2018 (Occupational Health & Safety), 
          demonstrating our commitment to excellence, sustainability and safety in every project.
        </p>
      </section>

      <section>
        <h3>Contact ROY.INOX - Royal Middle East International</h3>
        <p>
          Address: Dubai Investment Park (DIP) - Phase 2, P.O. Box 24381, Dubai, UAE. 
          Phone: +971 4 8898577. Email: arun@rmefandbeqpt.com. 
          Our 35,000 sq ft manufacturing facility serves the entire UAE with in-house 
          fabrication, design, and installation teams.
        </p>
      </section>
    </div>
  );
};

export default SEOContent;
